<template>
  <v-app>
    <v-container fluid>
       <v-row>
         <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Nominee Report Search
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <!-- Filters Row 1 -->
                <v-row class="py-1 px-2 " style="margin-bottom: -22px;">
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.department_id"
                      :items="departments"
                      item-title="name"
                      item-value="id"
                      label="Department"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-office-building"
                    ></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.designation_id"
                      :items="designations"
                      item-title="name"
                      item-value="id"
                      label="Designation"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-badge-account"
                    ></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.employee_type_id"
                      :items="employeeTypes"
                      item-title="name"
                      item-value="id"
                      label="Employee Type"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-account-tie"
                    ></v-select>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-select
                      v-model="filters.status"
                      :items="statusOptions"
                      item-title="text"
                      item-value="value"
                      label="Status"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      prepend-inner-icon="mdi-account-check"
                    ></v-select>
                  </v-col>
                </v-row>

                <!-- Date Range Filters and Search Button Row 2 -->
                <v-row class="py-0 px-2" style="margin-top: -8px;">
                  <v-col md="3" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.from_date"
                      label="From Date"
                      density="compact"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-start"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      autocomplete="off"
                      clearable
                    ></v-date-input>
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.to_date"
                      label="To Date"
                      density="compact"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-end"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      autocomplete="off"
                      clearable
                    ></v-date-input>
                  </v-col>
                  <v-col md="3" cols="12">
                    <div class="d-flex justify-start align-center" style="gap: 12px;">
                      <v-btn 
                        class="bg-brand w-15" 
                        type="submit" 
                        ref="searchButton"
                        @click="loadReport"
                      >
                        Search
                      </v-btn>
                      <v-btn
                        class="bg-warning w-15"
                        type="button"
                        prepend-icon="mdi-refresh"
                        @click="clearFilters"
                        title="Reset all filters and search"
                      >
                        Reset
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Nominee Report List -->
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Nominee Report List
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search "
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="!filteredNominees.length"
                        >CSV</v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="!filteredNominees.length"
                        >EXCEL</v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="!filteredNominees.length"
                        >PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>

                <v-card class="overflow-x-auto">
                  <v-data-table
                    :headers="headers"
                    :items="filteredNominees"
                    :loading="loading"
                    v-model:items-per-page="itemsPerPage"
                    :search="search"
                    :hover="true"
                    density="compact"
                    class="min-width-1200"
                  >
                    <template v-slot:item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <template v-slot:item.employee_name="{ item }">
                      <span class="font-weight-medium">{{ item.employee_name }}</span>
                    </template>

                    <template v-slot:item.nominee_code="{ item }">
                      <span class="text-caption">{{ item.nominee_code || '-' }}</span>
                    </template>

                    <template v-slot:item.nominee_name="{ item }">
                      <span class="font-weight-medium">{{ item.nominee_name }}</span>
                    </template>

                    <template v-slot:item.relation="{ item }">
                      <v-chip size="small" variant="tonal" color="primary">
                        {{ item.relation }}
                      </v-chip>
                    </template>

                    <template v-slot:item.percentage="{ item }">
                      <v-chip size="small" variant="tonal" color="success">
                        {{ item.percentage }}%
                      </v-chip>
                    </template>

                    <template v-slot:item.mobile="{ item }">
                      <span class="text-caption">{{ item.mobile || '-' }}</span>
                    </template>

                    <template v-slot:item.email="{ item }">
                      <span class="text-caption">{{ item.email || '-' }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <v-chip 
                        :color="item.status === 1 ? 'success' : 'error'" 
                        size="small" 
                        variant="tonal"
                      >
                        {{ item.status === 1 ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        @click="viewEmployee(item.employee_id)"
                        icon="mdi-eye"
                        size="small"
                        color="primary"
                        variant="text"
                        title="View Employee"
                      ></v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- No Data Message -->
      <v-card v-if="!loading && (!reportData.nominees || reportData.nominees.length === 0)" class="mt-4">
        <v-card-text class="text-center py-8">
          <v-icon size="64" color="grey-lighten-1">mdi-account-group</v-icon>
          <div class="text-h6 text-grey mt-4">No Nominee Data Found</div>
          <div class="text-body-2 text-grey">Try adjusting your search criteria</div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { toast } from 'vue3-toastify'
import formattedDate from '@/plugins/dateFormatter';

// Router and Store
const router = useRouter()
const store = useStore()

// Get Vue instance for export functions
const instance = getCurrentInstance()

// Reactive data
const panel = ref([0])
const search = ref('')
const loading = ref(false)
const itemsPerPage = ref(10)
const reportData = ref({ nominees: [] })
const departments = ref([])
const designations = ref([])
const employeeTypes = ref([])

// Filters
const filters = reactive({
  department_id: null,
  designation_id: null,
  employee_type_id: null,
  status: null,
  from_date: null,
  to_date: null
})

// Status options
const statusOptions = ref([
  { text: 'Active', value: 1 },
  { text: 'Inactive', value: 0 }
])

// Table headers
const headers = ref([
  { title: '#SL', key: 'index', sortable: false, align: 'center' },
  { title: 'Employee Name', key: 'employee_name', sortable: true, align: 'center' },
  { title: 'Nominee Name', key: 'nominee_name', sortable: true, align: 'center' },
  { title: 'Nominee Code', key: 'nominee_code', sortable: true, align: 'center' },
  { title: 'Department', key: 'department', sortable: true, align: 'center' },
  { title: 'Designation', key: 'designation', sortable: true, align: 'center' },
  { title: 'Relation', key: 'relation', sortable: true, align: 'center' },
  // { title: 'Percentage', key: 'percentage', sortable: true, align: 'center' },
  { title: 'Mobile', key: 'mobile', sortable: true, align: 'center' },
  { title: 'Email', key: 'email', sortable: true, align: 'center' },
  { title: 'Status', key: 'status', sortable: true, align: 'center' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '80px' }
])

// Computed properties
const filteredNominees = computed(() => {
  if (!search.value) return reportData.value.nominees || []
  
  const searchQuery = search.value.toLowerCase().trim()
  if (!searchQuery) return reportData.value.nominees || []
  
  const filtered = (reportData.value.nominees || []).filter(nominee => {
    if (nominee.employee_name && nominee.employee_name.toLowerCase().includes(searchQuery)) return true
    if (nominee.employee_code && nominee.employee_code.toLowerCase().includes(searchQuery)) return true
    if (nominee.nominee_name && nominee.nominee_name.toLowerCase().includes(searchQuery)) return true
    if (nominee.relation && nominee.relation.toLowerCase().includes(searchQuery)) return true
    if (nominee.department && nominee.department.toLowerCase().includes(searchQuery)) return true
    if (nominee.designation && nominee.designation.toLowerCase().includes(searchQuery)) return true
    return false
  })
  
  return filtered
})

// Methods
const loadReport = async () => {
  loading.value = true
  try {
    const params = {
      department_id: filters.department_id,
      designation_id: filters.designation_id,
      employee_type_id: filters.employee_type_id,
      status: filters.status,
      from_date: formattedDate(filters.from_date),
      to_date: formattedDate(filters.to_date),
    }
    
    const response = await store.dispatch('getNomineeReport', params)
    
    if (response.success) {
      reportData.value = response.data || { nominees: [] }
      // Ensure nominees is always an array
      if (!reportData.value.nominees || !Array.isArray(reportData.value.nominees)) {
        reportData.value.nominees = []
      }
    } else {
      console.error('API returned error:', response.message)
      toast.error(response.message || 'Failed to load nominee report')
      reportData.value = { nominees: [] }
    }
  } catch (error) {
    console.error('Error loading nominee report:', error)
    toast.error('Error loading nominee report: ' + error.message)
  } finally {
    loading.value = false
  }
}

const clearFilters = () => {
  filters.department_id = null
  filters.designation_id = null
  filters.employee_type_id = null
  filters.status = null
  filters.from_date = null
  filters.to_date = null
  search.value = ''
  loadReport()
}

const loadDropdowns = async () => {
  try {
    const [deptResponse, desigResponse, empTypeResponse] = await Promise.all([
      store.dispatch('getDepartments'),
      store.dispatch('getDesignations'),
      store.dispatch('getEmployeeTypes')
    ])
    
    // Ensure we always have arrays
    departments.value = Array.isArray(deptResponse?.data?.data) ? deptResponse.data.data : []
    designations.value = Array.isArray(desigResponse?.data?.data) ? desigResponse.data.data : []
    employeeTypes.value = Array.isArray(empTypeResponse?.data?.data) ? empTypeResponse.data.data : []
  } catch (error) {
    console.error('Error loading dropdowns:', error)
    // Ensure arrays are set even on error
    departments.value = []
    designations.value = []
    employeeTypes.value = []
  }
}

const viewEmployee = (employeeId) => {
  router.push(`/hrm/employee-details/${employeeId}`)
}

// Export functions
const exportToCSV = () => {
  const data = [['#', 'Employee Name', 'Nominee Name', 'Nominee Code', 'Department', 'Designation', 'Relation', 'Percentage', 'Mobile', 'Email', 'Status']]
  
  filteredNominees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee_name || '-',
      item.nominee_name || '-',
      item.nominee_code || '-',
      item.department || '-',
      item.designation || '-',
      item.relation || '-',
      item.percentage ? `${item.percentage}%` : '-',
      item.mobile || '-',
      item.email || '-',
      item.status === 1 ? 'Active' : 'Inactive'
    ])
  })
  
  instance.proxy.$exportTableToCSV(data, "nominee_report_" + instance.proxy.$fileDate())
}

const exportToExcel = () => {
  const data = [['#', 'Employee Name', 'Nominee Name', 'Nominee Code', 'Department', 'Designation', 'Relation', 'Percentage', 'Mobile', 'Email', 'Status']]
  
  filteredNominees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee_name || '-',
      item.nominee_name || '-',
      item.nominee_code || '-',
      item.department || '-',
      item.designation || '-',
      item.relation || '-',
      item.percentage ? `${item.percentage}%` : '-',
      item.mobile || '-',
      item.email || '-',
      item.status === 1 ? 'Active' : 'Inactive'
    ])
  })
  
  instance.proxy.$exportTableToExcel(data, "nominee_report_" + instance.proxy.$fileDate())
}

const exportToPDF = () => {
  let serialNumber = 1
  const columns = [
    "#", 
    "Employee Name", 
    "Nominee Name",
    "Nominee Code", 
    "Department",
    "Designation",
    "Relation",
    "Percentage",
    "Mobile",
    "Email",
    "Status"
  ]
  const rows = filteredNominees.value.map((item) => [
    serialNumber++,
    item.employee_name || '-',
    item.nominee_name || '-',
    item.nominee_code || '-',
    item.department || '-',
    item.designation || '-',
    item.relation || '-',
    item.percentage ? `${item.percentage}%` : '-',
    item.mobile || '-',
    item.email || '-',
    item.status === 1 ? 'Active' : 'Inactive'
  ])
  
  instance.proxy.$exportTableToPDF(columns, rows, "Nominee Report", "nominee_report_" + instance.proxy.$fileDate())
}

// Lifecycle
onMounted(() => {
  loadDropdowns()
  loadReport()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

.min-width-1200 {
  min-width: 1200px;
}
</style>
